<template>
    <paper class="performance-table-box-wrapper">
        <table-box ref="tablePage"
                   border
                   :columns="config.table.columns"
                   :height="config.table.height"
                   v-loading="loading"
                   :rows="tableData"
                   :actions="config.table.action"
                   :selection="config.table.selectBtn"
                   @action-click="actionClick"
                   @selection-change="handleSelectionChange">
                   <template #col-append="scope">
                        <span
                            class="cell-clickable"
                            v-if="scope.col.type === 'clickable'"
                            @click="onCellClick(scope)"
                        >
                            {{ scope.row[scope.col.prop] }}
                        </span>
                   </template>
        </table-box>
        <!-- 分页 -->
        <el-pagination background
                       class="table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       :pager-count="5"
                       :page-sizes="config.page.pageSizes || [10, 20, 30, 50]"
                       :layout="config.page.layout"
                       :total="total">
        </el-pagination>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import TableBox from '@/components/lots/tableBox/Index.vue';
export default {
    name: 'PerformanceTableBox',
    components: {
        paper,
        TableBox
    },
    props: {
        config: {
            type: Object,
            default () {
                return {};
            }
        },
        loading: {
            type: Boolean
        },
        tableData: {
            type: Array
        },
        currentPage: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        }
    },
    methods: {
        handleSelectionChange (data) {
            this.$emit('selection-change', data);
        },
        onCellClick({ col, row, rIndex }) {
            this.$emit('cell-click', row[col.prop], rIndex, row, col.prop);
        },
        actionClick (event, row, rIndex) {
            this.$emit('action-click', event, row, rIndex);
        },
        handleSizeChange (data) {
            this.$emit('size-change', data);
        },
        handleCurrentChange (data) {
            this.$emit('current-change', data);
        }
    }
};
</script>

<style lang="less">
.performance-table-box-wrapper {
    min-width: 400px !important;
    .table-pagination {
        margin-top: 12px;
    }

    .cell-clickable {
        cursor: pointer;
        color: #00BCBF;
    }
}
</style>
